// extracted by mini-css-extract-plugin
module.exports = {"loginCard":"Login_loginCard__d6lXI","logo":"Login_logo__2ERAl","backArrow":"Login_backArrow__1l3vu"};